import { StyleSheet, TextStyle, ViewStyle } from 'react-native'

import spacings from '@common/styles/spacings'
import flexbox from '@common/styles/utils/flexbox'

interface Style {
  root: ViewStyle
  noPositions: TextStyle
  noPositionsWrapper: ViewStyle
  skeletonOverlay: ViewStyle
  skeletonOverlayInner: ViewStyle
}

const styles = StyleSheet.create<Style>({
  root: {
    flex: 1
  },
  noPositionsWrapper: {
    ...flexbox.flex1,
    ...flexbox.center
  },
  noPositions: {
    textAlign: 'center',
    ...flexbox.flex1,
    ...spacings.mtTy
  },
  skeletonOverlay: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 50,
    bottom: 0,
    alignItems: 'center'
  },
  skeletonOverlayInner: {
    maxWidth: 990,
    width: '100%',
    height: '100%',
    marginHorizontal: 'auto'
  }
})

export default styles
